var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.99939C21 6.65637 16.9706 7.99963 12 7.99963C7.02944 7.99963 3 6.65637 3 4.99939M21 4.99939C21 3.3424 16.9706 1.99915 12 1.99915C7.02944 1.99915 3 3.3424 3 4.99939M21 4.99939V19.0005C21 19.7962 20.0518 20.5593 18.364 21.122C16.6761 21.6846 14.3869 22.0007 12 22.0007C9.61305 22.0007 7.32387 21.6846 5.63604 21.122C3.94821 20.5593 3 19.7962 3 19.0005V4.99939M3 11.9999C3 12.7957 3.94821 13.5588 5.63604 14.1214C7.32387 14.6841 9.61305 15.0002 12 15.0002C14.3869 15.0002 16.6761 14.6841 18.364 14.1214C20.0518 13.5588 21 12.7957 21 11.9999",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/DatabaseIcon.c36949510aca3ee9b0f5984676707e7f.svg";
export { ForwardRef as ReactComponent };